import React from 'react'
import { connect } from 'react-redux'
import {
  selectActiveFilters,
  applyFilter
} from '../../../redux/modules/search'
import  SearchFilters from '../components/SearchFilters'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import { toJS } from '../../../util/ToJS'
import {selectEntryTopicTitles} from '../../../redux/modules/entryTopicTitles'
import {withRouter} from 'react-router'
import omit from 'lodash/omit'
import qs from 'query-string'

class VisibleSearchFilters extends React.PureComponent {
  render() {
    const { activeFilters, applyFilter, titles, location } = this.props
    const pillOrder = [
      8951, // 'math-foundations'
      4106, // 'algebra-1'
      10005,// 'hs-biology'
      4712, // 'algebra-2'
      1, // 'calculus'
      752, // 'geometry'
      1943, // 'astronomy'
      1618, // 'physics'
      7587, // 'biology'
      9213, //'earth-science'
      7954,// 'chemistry'
      5525// 'advanced-topics'
    ]
    const pills = pillOrder.map(subject => ({
      id: subject,
      filter: titles[subject],
      color: SubjectToCSSName[subject],
      active: activeFilters.indexOf(titles[subject]) !== -1 ? true : false
    }))
    return <SearchFilters location={location} pills={pills} applyFilter={applyFilter} />
  }
}

const mapStateToProps = state => ({
  ...selectActiveFilters(state),
  titles:selectEntryTopicTitles(state)
})

const mapDispatchToProps = (dispatch,{history}) => {
  return {
    applyFilter: filter => {
      let query = qs.parse(window.location.search, {arrayFormat: 'bracket'})
      if (!query.filters) {
        query.filters = [filter]
      } else {
        const filterIndex = query.filters.indexOf(filter)
        if (filterIndex !== -1) {
          if (query.filters.length === 1) {
            query = omit(query, 'filters')
          } else {
            query.filters.splice(filterIndex, 1)
          }
        } else {
          query.filters.push(filter)
        }
      }
      history.replace({
        pathname: '/search',
        search: qs.stringify(query, {arrayFormat: 'bracket'})
      })
      dispatch(applyFilter(filter))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  toJS(VisibleSearchFilters)
))



// WEBPACK FOOTER //
// ./src/domains/search/containers/VisibleSearchFilters.js